var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 343,
    viewBox: "0 0 303 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.685782 62.3789C3.72461 140.216 5.74425 182.621 12.3197 246.624C17.882 271.099 23.766 281.226 42.8588 288.134C118.896 309.838 172.236 327.216 234.091 342.024C259.276 341.42 268.254 334.859 276.264 320.177C289.952 268.391 292.511 211.689 302.441 139.573C303.772 111.761 298.266 100.465 276.264 88.5957C195.657 54.7465 78.4877 8.48892 78.4877 8.48892C78.4877 8.48892 56.0909 -2.28758 42.8588 0.478247C27.3832 5.33123 20.6508 10.7047 12.3197 21.5973C2.70848 34.4498 0.191168 43.3867 0.685782 62.3789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftWhite);
export default __webpack_public_path__ + "static/media/LeftWhite.b8e2181e7b22686c2b83294f241fc609.svg";
export { ForwardRef as ReactComponent };